const CheckBox = ({
    field = '',
    label = '',
    value = false,
    isRequired = true,
    onChange,
    onClickLabel
}: IPropsCheckBox) => {

    const change = (e:any) => {
        let event = { target:{} as any };
        event.target.value = e.target.checked;
        event.target.name = field;
        if (e.target)
            onChange(field,e.target.checked);
    }

    return (
        <div className="checkbox-g-autohn mt-30 mb-5">
            <div className="checkbox-autohn">
                <input type="checkbox" checked={value} onChange={change} name={field} id="checkbox-autohn" required={isRequired} />
                <label htmlFor="checkbox-autohn"></label>
            </div>
            <span  className="lbl-checkbox-autohn" onClick={onClickLabel}>
                {label}
            </span>
        </div>
    );
}

export { CheckBox };